<template>
  <div class="edit">
    <div class="edit_top">
      <router-link to="/assigns/edit" class="edit_router">
        {{ edit }}
      </router-link>
    </div>
    <div class="detail">
      <div class="detail_contents">
        <div class="detail_top">
          <div class="assign_name_label detail_label">
            {{ nameLabel }}
          </div>
          <div class="assign_name detail_top_title">
            {{ assign.name }}
          </div>
        </div>
        <div class="detail_bottom">
          <div class="type_label detail_label">
            {{ typeLabel }}
          </div>
          <div class="user_id">
            <div class="assign_style_area" :style="{ backgroundColor: typeStyle.background, color: typeStyle.text, border: typeStyle.border}">
              {{ selectedTypeName(assign.type) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      edit: '編集',
      nameLabel: '役割',
      typeLabel: '色'
    }
  },
  computed: {
    assign() {
      return this.$store.state.assigns.assign
    },
    typeStyle() {
      return this.selectedTypeStyle(this.assign.type)
    }
  },
  methods: {
    selectedTypeName(typeId) {
      let name = ''
      let selectedType = this.$store.state.assigns.typeList.find(
        type => type.id === typeId
      )
      if (selectedType) {
        name = selectedType.name
      }
      return name
    }, 
    selectedTypeStyle(typeId) {
      let selectedType = this.$store.state.assigns.typeList.find(
        type => type.id === typeId
      )
      if (selectedType) {
        return {
          border : '2px solid ' + selectedType.border,
          background : selectedType.background,
          text : selectedType.text
        }
      }
        return {
          border : '',
          background : '',
          text : ''
        }
    }
  }
}
</script>
<style scoped>
.assign_style_area{
  padding: 5px;
  display: inline-block;
  border-radius: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/assigns/assignDetail.vue